import { cx } from "@/utils";
import {
  DropdownMenuSeparator,
  DropdownMenuSeparatorProps,
} from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

const DropdownSeparator: React.FunctionComponent<
  DropdownMenuSeparatorProps
> = ({ className, ...props }) => {
  return (
    <DropdownMenuSeparator
      className={cx(styles.separator, className)}
      {...props}
    />
  );
};

export default DropdownSeparator;
